(function ($) {
    $(async function () {
        const uri = window.URI();
        if (uri.hasQuery("contact", true)) {
            // user reached here from another link explicitly wanted to contact the Administrator.
            // after Tidio finished loading, open the chat dialog.
            abp.ui.setBusy();

            const onTidioChatApiReady = function () {
                window.tidioChatApi.open();
                abp.ui.clearBusy();
            };

            if (window.tidioChatApi) {
                window.tidioChatApi.on("ready", onTidioChatApiReady);
            } else {
                document.addEventListener("tidioChat-ready", onTidioChatApiReady);
            }
        }

        const $loginForm = $("form.login-form");
        const particles = new window.Particles("#kt_login_signin_submit", {
            type: "triangle",
            style: "stroke",
            size: 5,
            duration: 500,
            speed: 1.5,
            particlesAmountCoefficient: 7,
            oscillationCoefficient: 15,
            direction: "right"
        });

        abp.ajax.handleTargetUrl = (function () {
            const original = abp.ajax.handleTargetUrl;
            return function (targetUrl) {
                app.showLoader(function () {
                    original(targetUrl);
                });
            };
        })();

        $loginForm.validate({
            submitHandler: function (form) {
                var submit = function () {
                    particles.disintegrate({
                        complete: function () {
                            const sendAuthenticationRequest = function (data) {
                                abp.ajax({
                                    contentType: app.consts.contentTypes.formUrlEncoded,
                                    url: $(form).attr("action"),
                                    data: data,
                                    abpHandleError: false,
                                    errorCallback: function (data) {
                                        if (data.result) {
                                            if (data.result.publicKey !== undefined) {
                                                $(form).data("public-key", data.result.publicKey);
                                            }
                                        }
                                    }
                                }).done(async function () {
                                    abp.ui.clearBusy(null);

                                    await app.sessionStorage.removeItem("auto-relogin");
                                }).fail(async function (error) {
                                    const showError = async function () {
                                        await app.sessionStorage.removeItem("auto-relogin");

                                        abp.ajax.showError(error)
                                            .done(function () {
                                                particles.integrate();

                                                $(form).find("#Password").focus().select();
                                            });
                                    };

                                    abp.ui.clearBusy(null);

                                    if (error && error.status && error.status === 405) {
                                        // cater for anti forgery token mismatch
                                        // attempt to auto relogin if there's an anti-forgery token mismatch by saving the username and password, then refreshing the page
                                        // and re-enter the saved username and password and relogin.
                                        let relogin = await app.sessionStorage.getItem("auto-relogin");
                                        if (!relogin || relogin.count <= 3) {
                                            relogin = {
                                                username: $("#UserName", $loginForm).val(),
                                                password: $("#Password", $loginForm).val(),
                                                rememberMe: $("#RememberMe", $loginForm).prop("checked"),
                                                count: relogin ? ++relogin.count : 1
                                            };

                                            await app.sessionStorage.setItem("auto-relogin", relogin);

                                            location.reload();
                                        } else {
                                            showError();
                                        }
                                    } else {
                                        showError();
                                    }
                                });
                            };

                            abp.ui.setBusy(null);
                            const formData = $(form).serializeFormToObject(null, [$(form).data("recaptcha-response-key-name"), $(form).data("recaptcha-action-key-name")]);
                            const pem = $(form).data("public-key");
                            if (pem) {
                                abp.ajax({
                                    type: "GET",
                                    url: `${abp.appPath}api/heartbeat`
                                }).done(async function (heartBeatResult) {
                                    // fetch the part of the PEM string between header and footer
                                    const pemHeader = "-----BEGIN PUBLIC KEY-----";
                                    const pemFooter = "-----END PUBLIC KEY-----";
                                    const pemContents = pem.substring(
                                        pemHeader.length,
                                        pem.length - pemFooter.length
                                    );

                                    // base64 decode the string to get the binary data
                                    // convert from a binary string to an ArrayBuffer
                                    const binaryDer = app.utils.string.fromBase64(pemContents);

                                    const publicKey = await window.crypto.subtle.importKey(
                                        "spki",
                                        binaryDer,
                                        {
                                            name: "RSA-OAEP",
                                            hash: "SHA-256",
                                        },
                                        true,
                                        ["encrypt"]
                                    );

                                    const payload = {
                                        password: formData.password,
                                        timestamp: heartBeatResult.timestamp
                                    };

                                    const textEncoder = new TextEncoder();
                                    const encodedPayload = textEncoder.encode(JSON.stringify(payload));
                                    const cipherText = await window.crypto.subtle.encrypt(
                                        {
                                            name: "RSA-OAEP"
                                        },
                                        publicKey,
                                        encodedPayload
                                    );
                                    formData.password = app.utils.string.toBase64(cipherText);

                                    sendAuthenticationRequest(formData);
                                }).fail(function () {
                                    abp.ui.clearBusy(null);
                                    particles.integrate();
                                });
                            } else {
                                sendAuthenticationRequest(formData);
                            }
                        }
                    });
                };

                if (abp.setting.getBoolean("App.UserManagement.UseCaptchaOnLogin") && typeof window.grecaptcha !== "undefined") {
                    window.grecaptcha.reExecute(function () {
                        submit();
                    });
                } else {
                    submit();
                }
            }
        });

        $("a.social-login-icon").click(function () {
            const $a = $(this);
            const $form = $a.closest("form");
            $form.find("#Provider").val($a.attr("data-provider"));
            $form.submit();
        });
        
        // on page load check if there was a previous attempt before page refresh to login but failed due to anti-forgery token mismatch.
        // if there is, then auto relogin.
        const relogin = await app.sessionStorage.getItem("auto-relogin");
        if (relogin) {
            if (relogin.username && relogin.password) {
                $("#UserName", $loginForm).val(relogin.username);
                $("#Password", $loginForm).val(relogin.password);
                $("#RememberMe", $loginForm).prop("checked", relogin.rememberMe);

                $("#kt_login_signin_submit", $loginForm).click();
            }
        }
    });
})(jQuery);
